import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ICompanyListModel } from '@apps-common/types/management/company'

export const QUERY_KEY_MY_MONITORING_GET_COMPANIES_SELECT_LIST = () => ['getMyMonitoringCompaniesSelectList'].filter(Boolean)

const getMyMonitoringCompaniesSelectList = async (): Promise<ICompanyListModel[]> =>
  axios.get(`/my-monitoring/management/GetCompaniesSelectList`).then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringCompaniesSelectList

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useMyMonitoringManagementGetCompaniesSelectList = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_COMPANIES_SELECT_LIST(),
    queryFn: () => getMyMonitoringCompaniesSelectList()
  })
